import React from 'react';
import { useTenant } from '../../../context/TenantContext';
import { warmInlineEm } from './warmInlineEm';

export const WarmTestimonials: React.FC = () => {
  const { tenant } = useTenant();
  const marketing = tenant?.branding.marketing;
  const testimonials = (marketing?.testimonials ?? []).filter(
    t => t.quote?.trim() && t.authorName?.trim(),
  );
  if (testimonials.length === 0) return null;

  const heading = marketing?.copy?.testimonialsHeading?.trim() || 'Stories from *recent learners*.';

  // Rotation pattern per card — alternating to feel like polaroids
  // tossed onto a desk. Hover lifts to 0deg + slight raise.
  const tilts = ['-rotate-2', 'rotate-1 mt-5', '-rotate-1'];

  return (
    <section id="testimonials" className="warm-stories py-20 md:py-28 bg-[var(--warm-paper-deep)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14 md:mb-16">
          <div className="font-warm-hand text-2xl text-[var(--warm-accent-deep)] mb-2 -rotate-1 inline-block">
            In their own words
          </div>
          <h2 className="font-warm-serif text-3xl md:text-5xl leading-[1.05] tracking-tight text-[var(--warm-ink)] max-w-[22ch] mx-auto text-balance">
            {warmInlineEm(heading)}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-9 lg:gap-12">
          {testimonials.slice(0, 3).map((t, i) => (
            <article
              key={i}
              className={`warm-polaroid bg-white p-6 pb-7 rounded-[6px] shadow-[0_8px_24px_rgba(61,40,23,0.10)] transition-transform duration-300 hover:rotate-0 hover:-translate-y-1.5 ${tilts[i] ?? ''}`}
            >
              <div
                className="aspect-[4/5] mb-5 overflow-hidden bg-[var(--warm-paper-deep)]"
                style={{
                  backgroundImage: t.authorImageUrl ? `url(${t.authorImageUrl})` : undefined,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  background: t.authorImageUrl
                    ? `url(${t.authorImageUrl}) center / cover`
                    : `linear-gradient(135deg, var(--warm-accent-soft), var(--warm-accent))`,
                  filter: 'saturate(0.95)',
                }}
                aria-hidden="true"
              />
              <p className="font-warm-hand text-[22px] leading-[1.3] text-[var(--warm-ink)] mb-3">
                "{t.quote}"
              </p>
              <div className="text-sm font-bold text-[var(--warm-accent-deep)]">
                {t.authorName}
                {t.authorRole && (
                  <span className="font-medium text-[var(--warm-ink-soft)]"> / {t.authorRole}</span>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
